import React, { useEffect, useState } from "react";
import { Table, Button, Tag, message } from "antd";
import { CheckOutlined } from "@ant-design/icons";

import { getCodPendingReconciliationApi, markCodCollectedApi } from "../../services/api";

const ACCENT = "#534ab7";

function inr(v) {
  return `₹${(v ?? 0).toLocaleString("en-IN")}`;
}

export default function CodReconciliation() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [marking, setMarking] = useState(false);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const res = await getCodPendingReconciliationApi();
      setOrders(res.data.data || []);
      setSelectedIds([]);
    } catch {
      message.error("Failed to load pending COD reconciliations");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchOrders(); }, []);

  const handleMarkCollected = async (ids) => {
    setMarking(true);
    try {
      await markCodCollectedApi(ids);
      message.success(`Marked ${ids.length} order${ids.length > 1 ? "s" : ""} as COD collected`);
      fetchOrders();
    } catch (err) {
      message.error(err?.response?.data?.data || "Failed to mark as collected");
    } finally {
      setMarking(false);
    }
  };

  const columns = [
    {
      title: "Order",
      dataIndex: "orderNumber",
      render: (v, r) => (
        <div>
          <div style={{ fontWeight: 600 }}>{v}</div>
          <div style={{ fontSize: 11, color: "#888" }}>ID: {r.id}</div>
        </div>
      ),
    },
    {
      title: "Delivered On",
      dataIndex: "deliveredAt",
      render: (v) => (v ? new Date(v).toLocaleDateString("en-IN") : "-"),
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      render: (v) => <Tag color="volcano">{v}</Tag>,
    },
    {
      title: "Actions",
      width: 130,
      align: "center",
      render: (_, r) => (
        <Button icon={<CheckOutlined />} size="small" onClick={() => handleMarkCollected([r.id])} loading={marking}>
          Mark Collected
        </Button>
      ),
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedIds,
    onChange: setSelectedIds,
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">COD Reconciliation</div>
          <div className="page-sub">
            {orders.length} delivered COD orders awaiting confirmation that the courier's cash remittance actually landed
          </div>
        </div>
        <Button
          type="primary"
          icon={<CheckOutlined />}
          style={{ background: ACCENT, border: "none", borderRadius: 8 }}
          disabled={selectedIds.length === 0}
          loading={marking}
          onClick={() => handleMarkCollected(selectedIds)}
        >
          Mark {selectedIds.length || ""} Selected as Collected
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={orders}
        rowKey="id"
        rowSelection={rowSelection}
        loading={loading}
        size="small"
        locale={{ emptyText: "No pending COD reconciliations" }}
      />
    </div>
  );
}
